// removed by extract-text-webpack-plugin
module.exports = {"main":"SpeedDisplay-main--1ev16","status-ok":"SpeedDisplay-status-ok--3AhmP","status-warning":"SpeedDisplay-status-warning--21dgL","status-problem":"SpeedDisplay-status-problem--dY0EE","status-disconnected":"SpeedDisplay-status-disconnected--3NB4c","unit":"SpeedDisplay-unit--3iDjD","trend":"SpeedDisplay-trend---e9dT","trend-down":"SpeedDisplay-trend-down--ae3LZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SpeedDisplay/SpeedDisplay.scss
// module id = Y5R4
// module chunks = 4